export const URL = "https://trackteam.app/";
export const LINKEDIN_URL = "https://www.linkedin.com/company/trackteamapp";
export const INSTAGRAM_URL = "https://www.instagram.com/TrackTeamApp";
export const FACEBOOK_URL = "https://trackteam.app/";
export const TWITTER_URL = "https://trackteam.app/";